export default __webpack_public_path__ + "assets/images/18354f5a200be9cd2659d0a835af2647.png";